const Config = {
    // 测试环境
    development: {
        baseUrl: "https://gscservice.longtugame.cn",
        serverUrl:"//gmt-admin.longtugame.cn",
        imageHost: "res2-cdn-bbs.longtugame.com",
        payUrl:"https://sandbox-billing-usa.longtugame.net"             //billing.longtugame.cn
    },
    // 沙盒环境
    sandbox: {
        baseUrl: "http://172.16.200.116:9180",
        imageHost: "res2-cdn-bbs.longtugame.com",
        payUrl:"http://121.196.220.70:8092"
    },
    // 生产环境
    production: {
        baseUrl: "https://gscservice.longtugame.cn",
        serverUrl:"//gmt-admin.longtugame.cn",
        imageHost: "res2-cdn-bbs.longtugame.com",
        // payUrl:"https://sandbox-billing-usa.longtugame.net",             
        payUrl:"https://billing-usa.longtugame.net",
        hmId: {
            dy: 'f521ef0b446d691c7b4489511564837c',
            mt: '6245f992be1ef4d344227c4328751cd3',
            r3d: '93adb6f38bb87d00f95c73c959f714b2',
            yxwd: '5e3fe884696ab5b21fe467af16a2dc71',
            r:'93adb6f38bb87d00f95c73c959f714b2'
        }
    }
};

export default Config